import React from 'react';

import Dashboard from '../../components/dashboard/dashboard';
import './self-assessment-page.styles.scss';

export default function SelfAssessment() {
  return (
    <Dashboard title="Self Assessment" subtitle="Evaluate your progress">
      <div className="page-grid">
        <div className="col1">
          <div className="col1-row1">
            <div className="box">Col 1 - Row 1 (40%)</div>
          </div>
          <div className="col1-row2">
            <div className="box">Col 1 - Row 2 (60%)</div>
          </div>
        </div>
        <div className="col2">
          <div className="col2-row1">
            <div className="box">Col 2 - Row 1</div>
          </div>
          <div className="col2-row2">
            <div className="box">Col 2 - Row 2</div>
          </div>
          <div className="col2-row3">
            <div className="box">Col 2 - Row 3</div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
}
